import { SelectValue } from "antd/lib/select";
import { useEffect, useState } from "react"
import useFetchWrapper, { HttpResponse } from "../../../Helpers/useFetchWrapper";
import { FeedbackResponse, FeedbackState, Props, TableData, TabStatus, User } from "./ActiveTab.model";

export const pageSize = 10;

export const useActiveTab = ({filters}: Props) => {
	const [helpRequests, setHelpRequests] = useState<TableData[]>();
	const [pagination, setPagination] = useState({ page: 1, size: pageSize, total: 0 });
	const [admins, setAdmins] = useState<User[]>();
	const [tabStatus, setTabStatus] = useState<TabStatus>(TabStatus.Loading);

	const { get, put } = useFetchWrapper();

	const archiveFeedback = async (feedbackId: string) => {
		const response = await put(`/review/feedback-state/${feedbackId}`, FeedbackState.Archived);
		if (response.status === 200) getHelpRequests();
	}
	
	const assignRating = async (value: SelectValue, feedback: TableData) => {
		const response = await put(`/review/feedback-assign/${feedback.id}`, { userId: value});
		if (response.status === 200) getHelpRequests();
	}

	const reassignRating = async (value: SelectValue,  feedback: TableData) => {
		const response = await put(`/review/feedback-reassign/${feedback.id}`,  { userId: value});
		if (response.status === 200) getHelpRequests();
	}

	const getAdmins = async () => {
		const response: HttpResponse<{count: number, users: User[]}> = await get(`/user/admin?page=${1}&size=${100}`);
		if (response.parsedBody) {
			const { users } = response.parsedBody;
			setAdmins(users);
		}
	}

	const getHelpRequests = async () => {
		setTabStatus(TabStatus.Loading);
		const activefilters = filters?.includes('myFeedbacksOnly') ? filters : `${filters}&myFeedbacksOnly=false`;
		const response: HttpResponse<FeedbackResponse> = await get(`/review/help?state=${FeedbackState.Active}&page=${pagination.page}&size=${pagination.size}&${activefilters}`);
		if (response.parsedBody) {
			const { count, feedbacks } = response.parsedBody;
			setPagination({ ...pagination, total: count });
			setHelpRequests(feedbacks);
			setTabStatus(TabStatus.Loaded);
		}
		else {
			setTabStatus(TabStatus.Error);
		}
	}

	const isAssignedAdminDeleted = (adminId: string) => {
		return !admins?.find(admin => admin.userId === adminId);
	}

	const onChangeFeedbackPagination = (page: number) => {
		setPagination({...pagination, page })
	}

	const sendToSpam = async (feedbackId: string) => {
		const response = await put(`/review/feedback-state/${feedbackId}`, FeedbackState.Spam);
		if (response.status === 200) getHelpRequests();
	}

	useEffect(() => {
		getAdmins();
	}, []);

	useEffect(() => {
		if (pagination.page !== 1)
			setPagination({ ...pagination, page: 1 });
		else getHelpRequests();
	}, [filters]);
	
	useEffect(() => {
		getHelpRequests();
	}, [pagination.page]);

	return {
		archiveFeedback,
		assignRating,
		getHelpRequests,
		isAssignedAdminDeleted,
		onChangeFeedbackPagination,
		reassignRating,
		sendToSpam,
		state: {
			admins,
			helpRequests,
			pagination,
			tabStatus
		}
	}
}
